import type { ReactNode } from 'react';
import { cn } from '@shared/utils';

interface TabProps {
  className?: string;
  label: ReactNode;
  onClick?: () => void;
}

export const Tab = (props: TabProps) => {
  return (
    <li
      className={cn('flex h-[70px] cursor-pointer items-center justify-center text-center text-sm text-[#fcfcfc] uppercase', props.className)}
      onClick={props.onClick}
    >
      {props.label}
    </li>
  );
};
